import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Document } from 'src/app/models/document';
import { HighlightRect } from 'src/app/models/documentEvidence';
import { AclService } from 'src/app/services/acl.service';
import { DocumentRedactInfo } from 'src/app/models/documentRedactInfo';

export interface DrawRectangle {
  x: number,
  y: number,
  width: number,
  height: number
};


@Component({
  selector: 'app-edit-document-redacts',
  templateUrl: './edit-document-redacts.component.html',
  styleUrls: ['./edit-document-redacts.component.scss']
})
export class EditDocumentRedactsComponent {
  @Input() document?: Document;

  @Input() redacts: DocumentRedactInfo[] = []

  @Output() delete = new EventEmitter<DocumentRedactInfo>();
  @Output() close = new EventEmitter<any>();
  @Output() toggleDraw = new EventEmitter<any>();
  @Output() confirmRedact = new EventEmitter<DrawRectangle>();
  @Output() cancelAnnotation = new EventEmitter<any>();
  @Output() mouseenter = new EventEmitter<{
    redactId: string
  }>();
  @Output() mouseleave = new EventEmitter<{
    redactId: string
  }>();
  @Output() hoverRedactInfo = new EventEmitter<DocumentRedactInfo | null>();
  @Output() onToggleShowEvidencesWithRedacts = new EventEmitter<boolean>();

  @Input() isDraw: boolean = false;
  @Input() showEvidencesWithRedacts: boolean = true;
  @Input() drawing?: DrawRectangle;


  @Input() currentHighlight: HighlightRect | null = null;


  constructor(
    private readonly aclService: AclService,
  ) { }

  onMouseEnter(redactId?: string) {
    if (redactId) this.mouseenter.emit({ redactId });
  }
  onMouseLeave(redactId?: string) {
    if (redactId) this.mouseleave.emit({ redactId });
  }

  onClose() {
    this.close.emit();
  }

  onToggleDraw() {
    this.isDraw = !this.isDraw;
    this.toggleDraw.emit(this.isDraw)
  }

  async onConfirmRedact() {
    if (this.isDraw && this.drawing) {
      this.confirmRedact.emit(this.drawing);
      this.onCancelAnnotation();
    }
  }

  onCancelAnnotation() {
    this.cancelAnnotation.emit();
  }

  isManagerOrAbove() {
    return this.aclService.isManagerOrAbove();
  }
}
